// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__Derw2","alert":"Hero_alert__Wpk+W","message":"Hero_message__JHQfE","heading":"Hero_heading__fgb7A","paragraph":"Hero_paragraph__YRloE","image":"Hero_image__1Xg82"};